import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  Row,
  Col
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import MoneyInput from '../../../shared/components/MoneyInput';
import PromoCodeInput from '../../../shared/components/PromoCodeInput';
import DateInput from '../../../shared/components/DateInput';
import Button from '../../../shared/components/Button';

import moment from 'moment-timezone';

class ProviderPromoCodeInfo extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null,
      validationMessages:{}
    };
  }

  componentDidMount(){

    const loadingPromises = [];

    if(this.props.needsLoading){
      loadingPromises.push(this.props.loadPromoCode(this.props.existingPromoCodeId))
    }

    Promise
      .all(loadingPromises)
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after ProviderPromoCodeInfo in componentWillUnmount
  }

  handleSubmit(data){
    const validationMessages = {};

    const {
      isCreate,
      createPromoCode,
      updatePromoCode,
      history
    } = this.props;

    if(!data.code || (data.code && data.code.length === 0)){
      validationMessages['code'] = 'Promo code is required'
    }

    if(!data.amount || data.amount === 0){
      validationMessages['amount'] = 'Discount is required'
    }

    if(!data.expirationDate){
      validationMessages['expirationDate'] = 'Expiration date is required'
    }

    if(Object.keys(validationMessages).length > 0) {
      this.setState({validationMessages: validationMessages});
      return;
    }
    this.setState({validationMessages:{}});
    const localDate = moment(data.expirationDate)
    const expirationDate = moment.tz([localDate.year(), localDate.month(), localDate.date(), 23, 59, 59],
      "America/Los_Angeles").toISOString();
    if(this.props.isCreate){
      this.props.createPromoCode({
        code:data.code,
        amount:data.amount,
        expirationDate: expirationDate
      })
        .then(() => history.push('/superadmin/configuration/promocodes/'))
        .catch((err) => { validationMessages['code'] = err.toString(); this.setState({validationMessages: validationMessages}); });

    } else {
      this.props.updatePromoCode(this.props.existingPromoCodeId,{
        code:data.code,
        amount:data.amount,
        expirationDate:expirationDate
      })
        .then(() => history.push('/superadmin/configuration/promocodes/'))
        .catch((err) => { validationMessages['code'] = err.toString(); this.setState({validationMessages: validationMessages}); });
    }
  }

  render(){
    const { isCreate, existingPromoCode, needsLoading } = this.props;

    const formReady = isCreate || (!needsLoading && !!existingPromoCode);

    const { validationMessages } = this.state;

    return (
      <div>
        <Row>
          <Col xs='12'>
            <Button
              linkHref={`/superadmin/configuration/promocodes/`}
              textColor='black'
              backgroundColor='transparent'
            >
              <i className='fa fa-long-arrow-left' aria-hidden='true'></i>
              &nbsp;&nbsp;Back to All Promo Codes
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='6' md='6'>
            <br />
            {formReady ? (
              <Form onSubmit={(data) => this.handleSubmit(data)}>
                <PromoCodeInput
                  label='Promo Code'
                  name='code'
                  placeholder='ABC123'
                  defaultValue={isCreate ? '' :existingPromoCode.code}
                  warning={validationMessages['code']}
                />
                <MoneyInput
                  label='Discount'
                  name='amount'
                  placeholder='300'
                  defaultValue={isCreate ? '' :existingPromoCode.amount}
                  warning={validationMessages['amount']}
                />
                <DateInput
                  label='Expiration Date'
                  name='expirationDate'
                  defaultValue={isCreate ? '' :existingPromoCode.expirationDate}
                  warning={validationMessages['expirationDate']}
                />
                <Button isSubmit>
                  {isCreate ? 'Create Promo Code':'Update Promo Code'}
                </Button>
              </Form>
            ) : (
              <div>Loading...</div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

ProviderPromoCodeInfo.propTypes = {
  //TODO: Fill in prop types for ProviderPromoCodeInfo
};

ProviderPromoCodeInfo.defaultProps = {
  //TODO: Fill in defaultProps for ProviderPromoCodeInfo
};

export default ProviderPromoCodeInfo;



// WEBPACK FOOTER //
// ./src/routes/ProviderPromoCodeInfo/components/ProviderPromoCodeInfo.js